export class LookupData{
    public lookupId: string;
    public lookupValue: string;
    public lookupKey: string;
    public lookupCode: string;
    public selected: boolean;

}